export default __webpack_public_path__ + "static/media/Pilgrim's Belt of the Green Ones.c8ca01ef.jpg";